'use client';

import {
  Box,
  Button,
  DialogOpenChangeDetails,
  Flex,
  Input,
  Text,
} from '@chakra-ui/react';
import React, { useContext, useEffect, useState } from 'react';

import { useDeliveryInfo } from '~/hooks/resources/delivery_info';
import { apiClient } from '~/lib/apiClient';
import { RootContext } from '~/store';
import {
  DialogBackdrop,
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
} from '../ui/dialog';
import { Field } from '../ui/field';
import { toaster } from '../ui/toaster';
import { ProfileImage } from './ProfileImage';

export const ProfileModalForm: React.FC = () => {
  const [name, setName] = useState('');
  const { token, loggedInState } = useContext(RootContext);
  const { icon_image_url, nickname, loading, mutate } = useDeliveryInfo();
  const [isSubmitted, setIsSubmitted] = useState(Boolean);
  const [delivery_info_error, setDeliveryInfoError] = useState<string | null>();

  useEffect(() => {
    if (!loading) {
      const isModal = localStorage.getItem('modal');
      if (isModal == null) {
        localStorage.setItem('modal', 'open');
      }
      setIsSubmitted(isModal == 'open');
    }
  }, [icon_image_url, loading, nickname]);

  const handleSave = () => {
    setName(name);

    handleSelect();
  };

  const handleCancel = () => {
    localStorage.setItem('modal', 'close');
    setIsSubmitted(false);
  };

  const handleSelect = async () => {
    if (name != null) {
      //setSubmitting.on();
      if (name == '') {
        setDeliveryInfoError('ニックネームを入力してください。');
        return;
      } else {
        setDeliveryInfoError('');
      }

      try {
        const patch_res = await apiClient.v1.me.infos.patch({
          headers: {
            Authorization: `Bearer ${token?.token}`,
          },
          body: {
            nickname: name,
          },
        });
        if (patch_res.status === 204) {
          mutate();
          //setSubmitting.off();
          toaster.success({
            title: 'ニックネームを登録しました',
          });
          localStorage.setItem('modal', 'close');
        } else {
          {
            console.log('error');
          }
          //setSubmitting.off();
        }
      } catch (e) {
        console.log(e);
      }
    }
  };

  if (loading) return null;
  if (!(nickname == null || icon_image_url == null)) return null;

  return (
    <DialogRoot
      closeOnInteractOutside={false}
      open={
        loggedInState !== 'loading' &&
        isSubmitted &&
        (nickname == null || icon_image_url == null)
      }
      onOpenChange={(details: DialogOpenChangeDetails) => {
        if (!details.open) {
          handleCancel();
        }
      }}
    >
      <Flex
        flexDir="row"
        p="16px"
        justify="left"
        alignItems="center"
        border="1px"
        rounded="10px"
      >
        <DialogBackdrop />
        <DialogContent p="16px" maxW={{ base: '90%', sm: '400px' }}>
          <DialogHeader px="50px">
            アイコンとニックネームを登録してください。
          </DialogHeader>
          <DialogCloseTrigger onClick={handleCancel} />
          <Flex flex={1} flexDir="column" justifyContent="center" mx={2}>
            <DialogBody>
              <Text color="gray.400" fontSize="sm" px="16px">
                アイコンとニックネームは販売者へのメッセージ等に利用されます。後で設定することも可能です。
              </Text>
              <Box h="24px" />
              <ProfileImage />
              <Box h="24px" />
              <Field>
                <Input
                  type="string"
                  autoComplete="cc-name"
                  variant="flushed"
                  size="md"
                  placeholder="ニックネーム"
                  onChange={(e) => setName(e.target.value)}
                  css={{
                    '&:focus': {
                      borderColor: 'primary',
                    },
                  }}
                />
              </Field>
              <Text color="error" fontSize="sm">
                {delivery_info_error}
              </Text>
              <Box h="24px" />
            </DialogBody>
          </Flex>
          <DialogFooter>
            <Button
              color="#8859DD"
              fontSize="14px"
              fontWeight="thin"
              variant="ghost"
              onClick={handleCancel}
            >
              スキップ
            </Button>
            <Box w="8px" />
            <Button
              type="submit"
              h="32px"
              borderRadius="15px"
              border="1px"
              fontSize="14px"
              fontWeight="bold"
              colorPalette="white"
              bg="#8859DD"
              colorScheme="#8859DD"
              onClick={handleSave}
            >
              登録する
            </Button>
          </DialogFooter>
        </DialogContent>
      </Flex>
    </DialogRoot>
  );
};
